export const bands = {
    geo_hierarchy: "Geo Hierarchy",
    recommendation: "Recommendation",
    capital_spending_plan: "Capital Spending Plan",
    priority: "Priority",
    asset: "Asset",
    master_facility_plan: "Master Facility Plan",
    additional_details: "Additional Details",
    energy: "Energy",
    water: "Water",
    building: "Building",
    site: "Site",
    qa_qc: "QA/QC",
    other: "Others"
};

export const bandPositions = {
    header: 1,
    body: 2
};

export const tabs = {
    recommendation: {
        label: "Recommendation",
        bands: [
            bands.geo_hierarchy,
            bands.recommendation,
            bands.capital_spending_plan,
            bands.priority,
            bands.asset,
            bands.master_facility_plan,
            bands.additional_details,
            bands.energy,
            bands.water
        ]
    },
    building: {
        label: "Geo Hierarchy",
        bands: [bands.building, bands.site]
    },
    qa_qc: {
        label: "QA/QC",
        bands: [bands.qa_qc]
    },
    other: {
        label: "Others",
        bands: [
            bands.other
            // bands.water,
            // bands.energy
        ]
    }
};
